/**
 * @fileoverview gRPC-Web generated client stub for mlmbox.client.confirmation.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.15.8
// source: mlmbox/client/confirmation/v1/confirmation.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var mlmbox_type_confirmation_pb = require('../../../../mlmbox/type/confirmation_pb.js')

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')
const proto = {};
proto.mlmbox = {};
proto.mlmbox.client = {};
proto.mlmbox.client.confirmation = {};
proto.mlmbox.client.confirmation.v1 = require('./confirmation_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.mlmbox.client.confirmation.v1.ConfirmationClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.mlmbox.client.confirmation.v1.ConfirmationPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mlmbox.type.Confirmation.ID,
 *   !proto.mlmbox.type.Confirmation>}
 */
const methodDescriptor_Confirmation_Get = new grpc.web.MethodDescriptor(
  '/mlmbox.client.confirmation.v1.Confirmation/Get',
  grpc.web.MethodType.UNARY,
  mlmbox_type_confirmation_pb.Confirmation.ID,
  mlmbox_type_confirmation_pb.Confirmation,
  /**
   * @param {!proto.mlmbox.type.Confirmation.ID} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  mlmbox_type_confirmation_pb.Confirmation.deserializeBinary
);


/**
 * @param {!proto.mlmbox.type.Confirmation.ID} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mlmbox.type.Confirmation)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mlmbox.type.Confirmation>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mlmbox.client.confirmation.v1.ConfirmationClient.prototype.get =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mlmbox.client.confirmation.v1.Confirmation/Get',
      request,
      metadata || {},
      methodDescriptor_Confirmation_Get,
      callback);
};


/**
 * @param {!proto.mlmbox.type.Confirmation.ID} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mlmbox.type.Confirmation>}
 *     Promise that resolves to the response
 */
proto.mlmbox.client.confirmation.v1.ConfirmationPromiseClient.prototype.get =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mlmbox.client.confirmation.v1.Confirmation/Get',
      request,
      metadata || {},
      methodDescriptor_Confirmation_Get);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.mlmbox.type.Confirmation>}
 */
const methodDescriptor_Confirmation_All = new grpc.web.MethodDescriptor(
  '/mlmbox.client.confirmation.v1.Confirmation/All',
  grpc.web.MethodType.SERVER_STREAMING,
  google_protobuf_empty_pb.Empty,
  mlmbox_type_confirmation_pb.Confirmation,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  mlmbox_type_confirmation_pb.Confirmation.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.mlmbox.type.Confirmation>}
 *     The XHR Node Readable Stream
 */
proto.mlmbox.client.confirmation.v1.ConfirmationClient.prototype.all =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/mlmbox.client.confirmation.v1.Confirmation/All',
      request,
      metadata || {},
      methodDescriptor_Confirmation_All);
};


/**
 * @param {!proto.google.protobuf.Empty} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.mlmbox.type.Confirmation>}
 *     The XHR Node Readable Stream
 */
proto.mlmbox.client.confirmation.v1.ConfirmationPromiseClient.prototype.all =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/mlmbox.client.confirmation.v1.Confirmation/All',
      request,
      metadata || {},
      methodDescriptor_Confirmation_All);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mlmbox.client.confirmation.v1.ConfirmationGenerateOneTimePasswordRequest,
 *   !proto.mlmbox.type.Confirmation.Field.Notification>}
 */
const methodDescriptor_Confirmation_GenerateOneTimePassword = new grpc.web.MethodDescriptor(
  '/mlmbox.client.confirmation.v1.Confirmation/GenerateOneTimePassword',
  grpc.web.MethodType.UNARY,
  proto.mlmbox.client.confirmation.v1.ConfirmationGenerateOneTimePasswordRequest,
  mlmbox_type_confirmation_pb.Confirmation.Field.Notification,
  /**
   * @param {!proto.mlmbox.client.confirmation.v1.ConfirmationGenerateOneTimePasswordRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  mlmbox_type_confirmation_pb.Confirmation.Field.Notification.deserializeBinary
);


/**
 * @param {!proto.mlmbox.client.confirmation.v1.ConfirmationGenerateOneTimePasswordRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mlmbox.type.Confirmation.Field.Notification)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mlmbox.type.Confirmation.Field.Notification>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mlmbox.client.confirmation.v1.ConfirmationClient.prototype.generateOneTimePassword =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mlmbox.client.confirmation.v1.Confirmation/GenerateOneTimePassword',
      request,
      metadata || {},
      methodDescriptor_Confirmation_GenerateOneTimePassword,
      callback);
};


/**
 * @param {!proto.mlmbox.client.confirmation.v1.ConfirmationGenerateOneTimePasswordRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mlmbox.type.Confirmation.Field.Notification>}
 *     Promise that resolves to the response
 */
proto.mlmbox.client.confirmation.v1.ConfirmationPromiseClient.prototype.generateOneTimePassword =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mlmbox.client.confirmation.v1.Confirmation/GenerateOneTimePassword',
      request,
      metadata || {},
      methodDescriptor_Confirmation_GenerateOneTimePassword);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest,
 *   !proto.mlmbox.type.ConfirmationConfirmResponse>}
 */
const methodDescriptor_Confirmation_Confirm = new grpc.web.MethodDescriptor(
  '/mlmbox.client.confirmation.v1.Confirmation/Confirm',
  grpc.web.MethodType.UNARY,
  proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest,
  mlmbox_type_confirmation_pb.ConfirmationConfirmResponse,
  /**
   * @param {!proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  mlmbox_type_confirmation_pb.ConfirmationConfirmResponse.deserializeBinary
);


/**
 * @param {!proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mlmbox.type.ConfirmationConfirmResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mlmbox.type.ConfirmationConfirmResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mlmbox.client.confirmation.v1.ConfirmationClient.prototype.confirm =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mlmbox.client.confirmation.v1.Confirmation/Confirm',
      request,
      metadata || {},
      methodDescriptor_Confirmation_Confirm,
      callback);
};


/**
 * @param {!proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mlmbox.type.ConfirmationConfirmResponse>}
 *     Promise that resolves to the response
 */
proto.mlmbox.client.confirmation.v1.ConfirmationPromiseClient.prototype.confirm =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mlmbox.client.confirmation.v1.Confirmation/Confirm',
      request,
      metadata || {},
      methodDescriptor_Confirmation_Confirm);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mlmbox.type.Confirmation.ID,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Confirmation_Cancel = new grpc.web.MethodDescriptor(
  '/mlmbox.client.confirmation.v1.Confirmation/Cancel',
  grpc.web.MethodType.UNARY,
  mlmbox_type_confirmation_pb.Confirmation.ID,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.mlmbox.type.Confirmation.ID} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.mlmbox.type.Confirmation.ID} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mlmbox.client.confirmation.v1.ConfirmationClient.prototype.cancel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mlmbox.client.confirmation.v1.Confirmation/Cancel',
      request,
      metadata || {},
      methodDescriptor_Confirmation_Cancel,
      callback);
};


/**
 * @param {!proto.mlmbox.type.Confirmation.ID} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.mlmbox.client.confirmation.v1.ConfirmationPromiseClient.prototype.cancel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mlmbox.client.confirmation.v1.Confirmation/Cancel',
      request,
      metadata || {},
      methodDescriptor_Confirmation_Cancel);
};


module.exports = proto.mlmbox.client.confirmation.v1;

